import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';
import LazyLoad from 'react-lazyload';
const Sports = () => {
    useEffect(() => {
        document.title = 'Sports -  Sacred Heart School, Ballia - U.P.';  
    }, []); 
   return (
        <>
        <Header/>
            <section className="page-header"> 
                    <div className="page-header__inner">
                    <h2>Sports </h2>
                        <ul className="thm-breadcrumb list-unstyled ml-0">
                            <li><Link to="/"> Home</Link></li>
                            <li>|</li>
                            <li>Activities</li>
                            <li>|</li>
                            <li> Sports </li>
                        </ul> 
                </div>
            </section>
            <section className="innerbody">
               <div className='container'>
                <div className='row'>
                     <div className="col-lg-12">
                        <h1 className="head1">"All work and no play makes Jack a dull boy".</h1>
                        <p>Games and sports are important for success in every walk of our life. Games and sports include all outdoor and indoor games and also athletics. They are a regular feature of the school  curriculum. Boys and girls may practice races, jumps, discuss throw and javelin throw. They may play various games like football, cricket, hockey, volleyball, basket ball, badminton etc. The School aims at making its students  mentally alert and physically strong.Students learn to cope with difficult situations. By displaying their feats before many spectators, they can overcome their nervousness. For these reasons, every student is encouraged to participate actively in various sports activities. </p>
                    </div>
                </div>
                <div className="row sports"> 
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/sports1.jpg">
                            <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/sports1.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/sports2.jpg">
                            <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/sports2.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/sports3.jpg">
                            <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/sports3.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/sports4.jpg">
                            <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/sports4.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/sports5.jpg">
                            <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/sports5.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/sports6.jpg">
                            <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/sports6.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/sports7.jpg">
                            <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/sports7.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
            </div>
               </div>
             </section>
            <Footer/>
        </>
    )
}

export default Sports